// extracted by mini-css-extract-plugin
export default {"container":"TenantButtonList_container__EZOo2","buttons_wrapper":"TenantButtonList_buttons_wrapper__B9wLo"};